import { render, staticRenderFns } from "./Depart.vue?vue&type=template&id=2fff0786&scoped=true&"
import script from "./Depart.vue?vue&type=script&lang=js&"
export * from "./Depart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fff0786",
  null
  
)

export default component.exports